import { useTranslation } from "@opendash/i18n";
import { Select } from "antd";
import { observer } from "mobx-react-lite";
import React from "react";
import { AllConfigurableFields, ConfigurableField } from "../types/Config";

type Props = {
  alreadySelected?: ConfigurableField[];
  onChange?: (value: ConfigurableField) => void;
};

export const FieldConfigSelect = observer((props: Props) => {
  const t = useTranslation();

  const options = React.useMemo(
    () =>
      AllConfigurableFields.filter(
        (field) => !props.alreadySelected?.includes(field)
      ).map((field) => ({
        label: t(
          "maintenance:ticket.creation.config.form.field.label." + field
        ),
        value: field,
      })),
    [props.alreadySelected]
  );

  return (
    <Select
      options={options}
      onChange={(value) => props.onChange(value)}
      value={null}
      placeholder={t(
        "maintenance:ticket.creation.config.form.field.placeholder"
      )}
      style={{ minWidth: "10rem" }}
    />
  );
});
